import React from 'react';
import { Box, CircularProgress, Typography, Fade } from '@mui/material';

/**
 * PageLoader - A professional loading component for lazy-loaded pages
 * Used as fallback in Suspense boundaries
 */
const PageLoader = ({ message = 'Loading...' }) => {
  return (
    <Fade in timeout={300}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '60vh',
          gap: 3,
        }}
      >
        <CircularProgress
          size={48}
          thickness={4}
          sx={{
            color: 'primary.main',
          }}
        />
        <Typography
          variant="body1"
          color="text.secondary"
          sx={{
            fontWeight: 500,
            letterSpacing: 0.5,
          }}
        >
          {message}
        </Typography>
      </Box>
    </Fade>
  );
};

export default PageLoader;
